import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import SchedulePage from "@/pages/SchedulePage";
import StaffPage from "@/pages/StaffPage";
import RoutesPage from "@/pages/RoutesPage";
import CoveragePage from "@/pages/CoveragePage";
import RotaPage from "@/pages/RotaPage";
import FleetPage from "@/pages/FleetPage";
import PrintWeekPage from "@/pages/PrintWeekPage";
import PrintDayPage from "@/pages/PrintDayPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Navigate to="/schedule" replace />} />
            <Route path="/schedule" element={<SchedulePage />} />
            <Route path="/rota" element={<RotaPage />} />
            <Route path="/fleet" element={<FleetPage />} />
            <Route path="/coverage" element={<CoveragePage />} />
            <Route path="/staff" element={<StaffPage />} />
            <Route path="/routes" element={<RoutesPage />} />
          </Route>
          {/* Print view — outside Layout so the sidebar is hidden */}
          <Route path="/print/week" element={<PrintWeekPage />} />
          <Route path="/print/day" element={<PrintDayPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="light" richColors closeButton />
    </div>
  );
}

export default App;
